import { FlexBox } from '@Backlot-Cars/archie';
import styled from 'styled-components';

const FormContainer = styled(FlexBox).attrs(({ gap = '32px' }) => ({
	flexDirection: 'column',
	height: '100%',
	gap,
	flex: 1,
}))``;

export default FormContainer;
